import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Button } from "./ui/button";

export const MobileNavGuide = () => {
    const [show, setShow] = useState(false);

    const location = useLocation();

    useEffect(() => {
        let hasSeen = false;
        try {
            hasSeen = localStorage.getItem('hasSeenMobileNavGuide');
        } catch (e) {
            console.warn("LocalStorage access denied", e);
        }

        const token = localStorage.getItem("token");
        // lg breakpoint matching Navbar
        const isMobile = window.innerWidth < 1024;
        const isHome = location.pathname === '/';

        if (!hasSeen && isMobile && token && isHome) {
            // Small delay to ensure UI is ready
            const timer = setTimeout(() => setShow(true), 1500);
            return () => clearTimeout(timer);
        } else {
            setShow(false);
        }
    }, [location.pathname]);

    const dismiss = () => {
        try {
            localStorage.setItem('hasSeenMobileNavGuide', 'true');
        } catch (e) {
            console.warn("LocalStorage access denied", e);
        }
        setShow(false);
    };

    if (!show) return null;

    return (
        // Backdrop with blur and click-to-dismiss
        <div className="fixed inset-0 z-50 bg-black/60 backdrop-blur-[2px] animate-in fade-in duration-300" onClick={dismiss}>
            {/* Positioning container - aligned to top right */}
            {/* pt calculation: Navbar height approx 64px. Button center roughly 32px down. Arrow tip needs to be near 40px down. pointing up to 32px. */}
            <div className="absolute top-0 right-0 flex flex-col items-end pt-[60px] pr-2" onClick={(e) => e.stopPropagation()}>

                {/* Arrow */}
                <div className="animate-bounce mb-1 mr-2">
                    <svg
                        width="40"
                        height="40"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="white"
                        strokeWidth="3"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="drop-shadow-lg"
                    >
                        <path d="M12 19V5" />
                        <path d="M5 12l7-7 7 7" />
                    </svg>
                </div>

                <div className="bg-white p-5 rounded-2xl shadow-2xl max-w-[280px] relative animate-in slide-in-from-top-5 fade-in zoom-in-95 duration-500 origin-top-right">
                    {/* Tooltip triangle */}
                    <div className="absolute -top-2 right-8 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent border-b-[10px] border-b-white"></div>

                    <h3 className="font-bold text-lg text-gray-900 mb-2">Explore Menu</h3>
                    <p className="text-sm text-gray-600 mb-4 leading-relaxed">
                        Tap the hamburger menu to access all features like Search, Create Ride, and more.
                    </p>
                    <div className="flex justify-end">
                        <Button onClick={dismiss} className="bg-amber-500 hover:bg-amber-600 text-white font-semibold rounded-full px-6 shadow-sm">
                            Got it
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};
